import "../../../../App.css"
import { useEffect, useState } from 'react';
import NavbarVerical from '../../../Navbar/navbarVertical';
import { Card, Form, Row, Col, Button, DropdownButton, Table, FormControl } from 'react-bootstrap';
import { getAcademicYear, postProjectConfig } from "../../../api/projectconfig";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ProjectConfigurations() {
    const [selectedyear, setSelectedyear] = useState("");
    const [year, setYear] = useState([]);
    const [error, setError] = useState('');
    const [scrollerMsg, setScrollerMsg] = useState("");
    const [termsConditions, setTermsConditions] = useState("");
    const [errors, setErrors] = useState({});

    const token =
        typeof window !== "undefined" ? localStorage.getItem("token") : null;

    useEffect(() => {
        const fetchInitialData = async () => {
            try {
                const [cyearResponse,] = await Promise.all([
                    getAcademicYear(token),
                ]);
                setYear(cyearResponse.data);
            } catch (error) {
                setError("Error fetching data:", error);
            }
        };
        fetchInitialData();
    }, [token]);


    const handleYearchange = (event) => {
        setSelectedyear(event.target.value);
        setErrors(prev => ({ ...prev, selectedyear: "" }));
    };

    const validateInput = (value) => {
        if (!value.trim()) {
            return "This field is required.";
        }

        if (!/[a-zA-Z]/.test(value)) {
            return "Only numbers and special charater not allowed.";
        }

        return "";
    };


    const handleScrollarMsgChange = (e) => {
        const value = e.target.value;
        setScrollerMsg(value);

        if (value.trim()) {
            const error = validateInput(value);
            setErrors(prev => ({ ...prev, scrollerMsg: error }));
        } else {
            setErrors(prev => ({ ...prev, scrollerMsg: "" }));
        }
        // setErrors(prev => ({ ...prev, scrollerMsg: "" }));

        // if (value.trim()) {
        //     const fieldsError = validateScrollerMsg(value);
        //     setErrors(prev => ({ 
        //         ...prev, 
        //         scrollerMsg: fieldsError 
        //     }));
        // } else {
        //     setErrors(prev => ({ ...prev, scrollerMsg: "" }));
        // }
    };

    const handletermsconditionChange = (e) => {
        const value = e.target.value;
        setTermsConditions(value);
        if (value.trim()) {
        const error = validateInput(value);
        setErrors(prev => ({ ...prev, termsConditions: error }));
    } else {
        setErrors(prev => ({ ...prev, termsConditions: "" }));
    }
    };

    const handleSubmit = async () => {

        const newErrors = {};
        if (!selectedyear) newErrors.selectedyear = "Please select Active Academic Year.";
    
          const scrollerError = validateInput(scrollerMsg);
    if (scrollerError) newErrors.scrollerMsg = scrollerError;
    
    // Validate termsConditions
    const termsError = validateInput(termsConditions);
    if (termsError) newErrors.termsConditions = termsError;
    


        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        const projectConfiguration = {
            scrollerMsg: scrollerMsg,
            termsAndConditions: termsConditions,
        };

        try {
            const response = await postProjectConfig(
                projectConfiguration,
                token,
                selectedyear
            );
            toast.success("Project configuration saved successfully.");
            setSelectedyear([]);
            setScrollerMsg("");
            setTermsConditions("");
            handleCancel();
        } catch (error) {
            console.error("Error saving project configuration:", error);
            toast.error("Failed to save project configuration.");
        }
    };


    const handleCancel = () => {
        setSelectedyear("");
        setScrollerMsg("");
        setTermsConditions("");
        setErrors({});
    }

    return (
        <>
            <NavbarVerical />
            <div className="content-area">
                <Card>
                    <Card.Body>
                        <p style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }}>Project Configurations</p>
                        <Form>
                            <Row className='mt-4'>
                                <Col>

                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-4 col-form-label form-label"
                                        >
                                            Active Academic Year<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm={8} className="mb-3 mb-lg-0">
                                            <Form.Select type="text"
                                                id="ActiveAcademicYear"
                                                required
                                                value={selectedyear}
                                                onChange={handleYearchange}
                                            >
                                                <option value="">Select Academic Year</option>
                                                {year.map((academicyear) => (
                                                    <option key={academicyear.id} value={academicyear.id}>
                                                        {academicyear.sessionName}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                            {errors.selectedyear && (
                                                <div style={{ color: "red", fontSize: "13px", marginTop: "3px" }}>
                                                    {errors.selectedyear}
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-4 col-form-label form-label"
                                        >
                                            Scroller Msg<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm={8} className="mb-3 mb-lg-0">
                                            <Form.Control type="text"
                                                placeholder="Enter Scroller Msg"
                                                id="ScrollerMsg"
                                                required
                                                value={scrollerMsg}
                                                onChange={handleScrollarMsgChange}
                                            />
                                            {errors.scrollerMsg && (
                                                <div style={{ color: "red", fontSize: "13px", marginTop: "3px" }}>
                                                    {errors.scrollerMsg}
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Label
                                            className="col-sm-4 col-form-label form-label"
                                            htmlFor="courseDropdown"
                                        >
                                            Terms & Conditions<span className="text-danger">*</span>
                                        </Form.Label>
                                        <Col sm={8} className="mb-3 mb-lg-0">
                                            <Form.Control
                                                as="textarea"
                                                rows={3}
                                                placeholder="Enter Terms & Conditions ..."
                                                id="HomePageHeader"
                                                required value={termsConditions}
                                                onChange={handletermsconditionChange} />
                                            {errors.termsConditions && (
                                                <div style={{ color: "red", fontSize: "13px", marginTop: "3px" }}>
                                                    {errors.termsConditions}
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                </Col>
                                <Col></Col>
                            </Row>

                            <Row>
                                <Col className="d-flex align-items-center justify-content-center mb-3">
                                    <Button variant="primary" type="button"
                                        onClick={handleSubmit}
                                    >
                                        Submit
                                    </Button>
                                    <ToastContainer />
                                    <Button variant="secondary" type="button" style={{ marginLeft: "10px" }}
                                        onClick={handleCancel}
                                    >
                                        Cancel
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
            </div>


        </>
    );
}

export default ProjectConfigurations;